/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MandatePayer } from './MandatePayer';
import {
    MandatePayerFromJSON,
    MandatePayerFromJSONTyped,
    MandatePayerToJSON,
    MandatePayerToJSONTyped,
} from './MandatePayer';

/**
 * Payeur proposé aux conditions particulières d'un devis : la personne que la plateforme prélèverait si ce payeur était choisi.
 * @export
 * @interface MandatePayerOptionDto
 */
export interface MandatePayerOptionDto {
    /**
     * 
     * @type {MandatePayer}
     * @memberof MandatePayerOptionDto
     */
    code: MandatePayer;
    /**
     * Personne prélevée pour ce payeur (souscripteur, bénéficiaire ou cabinet du courtier)
     * @type {string}
     * @memberof MandatePayerOptionDto
     */
    personId?: string | null;
    /**
     * Nom de la personne prélevée
     * @type {string}
     * @memberof MandatePayerOptionDto
     */
    displayName?: string | null;
}



/**
 * Check if a given object implements the MandatePayerOptionDto interface.
 */
export function instanceOfMandatePayerOptionDto(value: object): value is MandatePayerOptionDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function MandatePayerOptionDtoFromJSON(json: any): MandatePayerOptionDto {
    return MandatePayerOptionDtoFromJSONTyped(json, false);
}

export function MandatePayerOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MandatePayerOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': MandatePayerFromJSON(json['code']),
        'personId': json['personId'] == null ? undefined : json['personId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function MandatePayerOptionDtoToJSON(json: any): MandatePayerOptionDto {
    return MandatePayerOptionDtoToJSONTyped(json, false);
}

export function MandatePayerOptionDtoToJSONTyped(value?: MandatePayerOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': MandatePayerToJSON(value['code']),
        'personId': value['personId'],
        'displayName': value['displayName'],
    };
}

